export const iconFontAwesomeHandsHandPointer = (
	<i className="fa-solid fa-hand-pointer"></i>
);
